//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  data() {
    return {
      scrollPosition: 'front',
      // interval: null
    }
  },
  props: {
    menu: {
      type: Object,
      default: () => {}
    },
    selectedCategory: {
      type: Object,
      default: () => {}
    },
  },
  methods: {
    slug(str) {
      str = str.toString().replace(/^\s+|\s+$/g, "");
      str = str.toLowerCase();
      let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      let to = "aaaaeeeeiiiioooouuuunc------";
      for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }
      str = str
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");

      return str
    },
    setSelectedCategory(category) {
      this.$store.commit('setSelectedCategory', category)
    },
    getScrollPosition() {
      const ul = document.querySelector('ul')
      let position = 'middle'
      if (ul.scrollLeft == 0) {
        position = 'front'
      } else if (ul.scrollWidth-ul.offsetWidth == Math.round(ul.scrollLeft)) {
        position = 'end'
      }
      this.scrollPosition = position
    },
    scrollLeft() {
      const ul = document.querySelector('ul')
      ul.scrollTo({
        left: ul.scrollLeft-200,
        behavior: 'smooth'
      })
    },
    scrollRight() {
      const ul = document.querySelector('ul')
      ul.scrollTo({
        left: ul.scrollLeft+200,
        behavior: 'smooth'
      })
    },
    // downRight() {
    //   this.interval = setInterval(this.scrollRight, 300)
    // },
    // downLeft() {
    //   this.interval = setInterval(this.scrollLeft, 300)
    // },
    // up() {
    //   clearInterval(this.interval)
    // }
  },
}
